export const originalDocumentDownloadUrl = (fseId: string): string =>
  `/files/document/original?fse_id=${encodeURIComponent(fseId)}`;
